'use client'
import { Dialog } from '@ark-ui/react/dialog'

import { type PopupVariantProps, popup } from 'styled-system/recipes'

import { createStyleContext } from './utils/create-style-context'

import type { Assign } from '@ark-ui/react'
import type { ComponentProps, HTMLStyledProps } from 'styled-system/types'

const { withRootProvider, withContext } = createStyleContext(popup)

export type RootProviderProps = ComponentProps<typeof RootProvider>
export const RootProvider = withRootProvider<
  Assign<Dialog.RootProviderProps, PopupVariantProps>
>(Dialog.RootProvider)

export type RootProps = ComponentProps<typeof Root>
export const Root = withRootProvider<
  Assign<Dialog.RootProps, PopupVariantProps>
>(Dialog.Root)

export const Backdrop = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Dialog.BackdropBaseProps>
>(Dialog.Backdrop, 'backdrop')

export const CloseTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, Dialog.CloseTriggerBaseProps>
>(Dialog.CloseTrigger, 'closeTrigger')

export const Window = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Dialog.ContentBaseProps>
>(Dialog.Content, 'window')

export const Header = withContext<HTMLDivElement, HTMLStyledProps<'div'>>(
  'div',
  'header',
)

export const Content = withContext<HTMLDivElement, HTMLStyledProps<'div'>>(
  'div',
  'content',
)

export const Footer = withContext<HTMLDivElement, HTMLStyledProps<'div'>>(
  'div',
  'footer',
)

export const Description = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Dialog.DescriptionBaseProps>
>(Dialog.Description, 'description')

export const Positioner = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Dialog.PositionerBaseProps>
>(Dialog.Positioner, 'positioner')

export const Title = withContext<
  HTMLHeadingElement,
  Assign<HTMLStyledProps<'h2'>, Dialog.TitleBaseProps>
>(Dialog.Title, 'title')

export const Trigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, Dialog.TriggerBaseProps>
>(Dialog.Trigger, 'trigger')

export { DialogContext as Context } from '@ark-ui/react/dialog'
